<app-product-filter (onFiltersChange)="filtersChange($event)" [columns]="columns"></app-product-filter>
<app-product-table (onColumnChange)="columnChange($event)" [filters]="filters"></app-product-table>
